import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import {getStatusColor, isCompanyAdmin, isCustomer, isDistributorAdmin, isSuperAdmin} from "../helpers/helpers";
import {filterUser} from "../store/actions/usersActions";
import './CommunitySensors.scss';
import './WeatherStations.scss';

import {
    getWeatherStations,
    selectWeatherStation,
    setWeatherStationsFilters
} from "../store/actions/weatherStationsActions";
import Spinner from "./_common/Spinner";
import List from "./_common/List";
import {toggleModal} from "../store/actions/toggleModalActions";
import WeatherStationModal from "./WeatherStationModal";
import DetailsModal from "./_common/DetailsModal";
import WeatherStationDetails from "./WeatherStationDetails";
import MapWithPopups from "./MapWithPopups";

const selector = state => {
    const { language, weatherStations, modalState, fields, users } = state;
    return {
        t: language.translator,
        pending: weatherStations.pending,
        weatherStations: weatherStations.weatherStations,
        page: weatherStations.page,
        pageCount: weatherStations.pageCount,
        itemsCount: weatherStations.itemsCount,
        selected: weatherStations.selected,
        filters: weatherStations.filters,
        modalState: modalState,
        fields: fields.fields,
        filteredUser: users.filtered,
    }
};

const WeatherStations = props => {
    const { t, pending, weatherStations, page, pageCount, itemsCount, modalState, selected, filters, fields, filteredUser } = useSelector(selector)
    const {stationPicker, selectStationPicker, toggleStationPicker} = props;
    const dispatch = useDispatch();

    const [filter, setFilter] = useState('ALL');
    const [search, setSearch] = useState('');
    const [pickerSearch, setPickerSearch] = useState('');
    const [rimOnly, setRimOnly] = useState(false);

    const [hideMap, setHideMap] = useState(isSuperAdmin() || isCompanyAdmin() || isCustomer() || isDistributorAdmin());
    const [itemsPerPage, setItemsPerPage] = useState(hideMap ? 10 : 3);

    useEffect(() => {
        if(isCompanyAdmin() || isSuperAdmin() || isDistributorAdmin()) {
            dispatch(filterUser({}));
            // dispatch(setCommunitySensorsFilters({active: 'ALL', itemsPerPage: hideMap ? 10 : 3, search: ''}))
            // dispatch(getAllFields());
            dispatch(getWeatherStations(1, itemsPerPage, '', false));
        } else {
            // dispatch(setCommunitySensorsFilters({active: 'ALL', itemsPerPage: hideMap ? 10 : 3, search: ''}))
            // dispatch(getFields());
            dispatch(getWeatherStations(1, itemsPerPage, '', false));
        }
        if(!stationPicker) {
            closeModal()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const closeModal = () => {
        dispatch(toggleModal(false, ''))
    };

    const getWeatherStationsPage = (pageNumber, numberPerPage, _filter, _userId, searchValue, _lat, _lon, _sensorType, rimOnlyValue) => {
        return getWeatherStations(pageNumber, numberPerPage, searchValue, rimOnlyValue);
    };

    let weatherStationsMarkers = [];

    if(weatherStations.length) {
        weatherStations.forEach(station => {
            if (station.lat && station.lon) {
                weatherStationsMarkers.push(
                    {
                        lat: station?.lat,
                        lng: station?.lon,
                        color: getStatusColor(station?.temperatureStatus),
                        name: station.name,
                        // loraIdentifier: sensor?.loraIdentifier,
                        // temperature: sensor?.temperature,
                        // humidity: sensor.measurements.length ? sensor.measurements[0].humidity : '',
                        // date: sensor.measurements.length ? sensor.measurements[0].dateTimeCreated.replace('T') : '',
                        id: station.id
                    }
                )
            }
        });
    }

    return (
        <div style={stationPicker ? { minWidth: '80vw', padding: '0 30px 50px'} : null} className='communitySensors'>
            {(isSuperAdmin() || isCompanyAdmin() || isDistributorAdmin()) && !stationPicker && (
            <div className={!hideMap ? 'sensorMap sensorMap--expanded' : 'sensorMap'}>
                {/*<SensorsMap*/}
                {/*    defaultZoom={5.8}*/}
                {/*    defaultCenter={{lat: 52.2297, lng: 21.0122}}*/}
                {/*    markers={weatherStationsMarkers}*/}
                {/*/>*/}
                <MapWithPopups
                    zoom={6}
                    center={{lat: 52.2297, lng: 21.0122}}
                    markers={weatherStationsMarkers}
                    mapType={'sensors'}
                />
                <div
                    className='hideMapButton'
                    onClick={() => {
                        dispatch(setWeatherStationsFilters({active: filter, itemsPerPage, search: filters.search, rimOnly: filters.rimOnly}))
                        dispatch(getWeatherStations(1, itemsPerPage, filters.search, filters.rimOnly));
                        setHideMap(!hideMap)
                    }}
                >
                    <span className='material-icons hideMapButtonIcon'>
                        {hideMap ? 'expand_more' : 'expand_less'}
                    </span>
                </div>
            </div>
                )}
            {!stationPicker &&
                <form className='sensorFilter stationFilter'>
                    <div className='searchInputWrapper'>
                        <input
                            type='text'
                            className='sensorSearchInput'
                            placeholder={t.gettext('Search')}
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                        />
                        {filters.search
                            ? <span
                                className='material-icons sensorSearchCancelButton'
                                onClick={() => {
                                    dispatch(setWeatherStationsFilters({active: filter, itemsPerPage, search: '', rimOnly}))
                                    setSearch('');
                                    dispatch(getWeatherStations(1, itemsPerPage, '', rimOnly));
                                    // dispatch(getSensors(1, itemsPerPage, filter, filteredUser.id ? filteredUser.id : 0, '', latSearch, lonSearch, typeFilter.name));
                                }}
                            >
                            cancel
                        </span>
                            : null
                        }
                    </div>
                    <label className='stationRimCheckboxLabel'>
                        <input
                            type='checkbox'
                            checked={rimOnly}
                            onChange={e => setRimOnly(e.target.checked)}
                        />
                        Rim
                    </label>
                    <button
                        className='sensorSearchButton'
                        onClick={e => {
                            e.preventDefault();
                            dispatch(setWeatherStationsFilters({active: filter, itemsPerPage, search, rimOnly}))
                            dispatch(getWeatherStations(1, itemsPerPage, search, rimOnly));
                            // dispatch(setSensorsFilters({active: 'ALL', itemsPerPage, search, lat: latSearch, lon: lonSearch, sensorType: typeFilter.name}))
                            // dispatch(getSensors(1, itemsPerPage, 'ALL', filteredUser.id ? filteredUser.id : 0, search, latSearch, lonSearch, typeFilter.name))
                        }}
                        disabled={!search && !rimOnly}
                    >
                        {t.gettext('SEARCH')}
                    </button>
                    <label htmlFor='itemsPerPage' className={'itemsPerPageLabel'}>
                        {t.gettext('Items per page')}
                    </label>
                    <input
                        type='number'
                        id='itemsPerPage'
                        className='sensorSearchInput itemsPerPageInput'
                        min={1}
                        step={1}
                        defaultValue={itemsPerPage}
                        onChange={e => {
                            e.preventDefault();
                            if(e.target.value) {
                                setItemsPerPage(e.target.value < 1 ? 1 : e.target.value);
                                dispatch(setWeatherStationsFilters({active: filter, itemsPerPage: e.target.value < 1 ? 1 : e.target.value, search: filters.search, rimOnly: filters.rimOnly}));
                                dispatch(getWeatherStations(1, e.target.value < 1 ? 1 : e.target.value, filters.search, filters.rimOnly));
                            }
                        }}
                    />
                    <div className="addStationWrapper">
                        <div className="addStationBtn" onClick={() => dispatch(toggleModal(true, 'Add Station'))}>
                            {t.gettext('Add Station')}
                        </div>
                    </div>
                </form>
            }
            {stationPicker &&
                <form
                    className='sensorFilter stationFilter stationPickerFilter'
                    onSubmit={e => {
                        e.preventDefault();
                        setPickerSearch(search);
                        dispatch(getWeatherStations(1, itemsPerPage, search, false));
                    }}
                >
                    <div className='searchInputWrapper'>
                        <input
                            type='text'
                            className='sensorSearchInput'
                            placeholder={t.gettext('Search')}
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                        />
                        {pickerSearch
                            ? <span
                                className='material-icons sensorSearchCancelButton'
                                onClick={() => {
                                    setSearch('');
                                    setPickerSearch('');
                                    dispatch(getWeatherStations(1, itemsPerPage, '', false));
                                }}
                            >
                                cancel
                            </span>
                            : null
                        }
                    </div>
                    <button
                        type='submit'
                        className='sensorSearchButton'
                        disabled={!search}
                    >
                        {t.gettext('SEARCH')}
                    </button>
                </form>
            }
            <div className={hideMap ? 'sensorList sensorList--expanded' : 'sensorList'}>
                {pending
                    ? <div className='page'>
                        <Spinner size={300}/>
                    </div>
                    : <List
                        roundTopCorners
                        items={weatherStations}
                        page={page}
                        itemsPerPage={itemsPerPage}
                        pageCount={pageCount}
                        itemsCount={itemsCount}
                        columnsNames={isCustomer() ?  ['', 'Code', 'Station Name', 'Rain Sensor', 'Wet Leaf Sensor'] : ['', 'Code', 'User Name', 'Station Name', 'Rain Sensor', 'Wet Leaf Sensor']}
                        columns={isCustomer() ? ['virtual', 'code', 'name', 'rainSensorId', 'wetLeafSensorId'] : ['virtual', 'code', 'userName', 'name', 'rainSensorId', 'wetLeafSensorId']}
                        columnsWidths={isCustomer() ? ['2%', '18%', '20%', '30%', '30%'] : ['2%', '18%', '15%', '15%', '25%', '25%']}
                        filter={filter}
                        rainSensorColumn={isCustomer() ? 4 : 5}
                        wetLeafSensorColumn={isCustomer() ? 5 : 6}
                        virtualStationColumn={1}
                        // measurementTimeColumn={3}
                        // booleanColumn={4}
                        picker={stationPicker}
                        getItemsMethod={getWeatherStationsPage}
                        selectItemMethod={stationPicker ? selectStationPicker : selectWeatherStation}
                        onSelectModalName={stationPicker ? toggleStationPicker : 'Station details'}
                        userId={filteredUser.id ? filteredUser.id : ''}
                        search={stationPicker ? pickerSearch : filters.search}
                        rimOnly={stationPicker ? false : filters.rimOnly}
                    />
                }
                {(modalState.flag && modalState.modal === 'Add Station') && (
                    <WeatherStationModal />
                )}
                {(modalState.flag && modalState.modal === 'Station details') &&
                    <DetailsModal
                        closeMethod={closeModal}
                        >
                        <WeatherStationDetails
                            station={selected.station}
                            />
                    </DetailsModal>
                }
            </div>
        </div>
    );
}

export default WeatherStations
